import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { lastValueFrom, Subscription } from 'rxjs';
import { User } from './dashboard/interfaces/user.interface';
import { ApiService } from "./services/api.service";
import { StoreService } from "./services/store.service";
import {LanguageService} from "./services/language.service";
import {UserRole} from "./dashboard/enums/role.enum";
import {MatIconRegistry} from "@angular/material/icon";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private isLoadingSubscription: Subscription = new Subscription();
  private userSubscription: Subscription = new Subscription();
  public user: User | null;
  public isLoading: boolean = false;
  public clientBackgroundUrl: string = '';
  private currentBlobUrl: string | null = null;

  constructor(private storeService: StoreService, private apiService: ApiService, private changeDetectorRef: ChangeDetectorRef, private languageService: LanguageService, private iconRegistry: MatIconRegistry) {
    this.user = this.storeService.user;
    this.languageService.setStoredLanguage();
    // iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }

  ngOnInit(): void {
    this.isLoadingSubscription = this.apiService.isLoadingSubject.subscribe((isLoading: boolean) => {
      setTimeout(() => {
        this.isLoading = isLoading;
        this.changeDetectorRef.detectChanges()
      });
    });

    this.userSubscription = this.storeService.user$.subscribe(async (user) => {
      if (user?.role === UserRole.admin || user?.role === UserRole.ankerslotSales) {
        this.clientBackgroundUrl = 'url(/assets/ankerslot_bg.jpg)';
        this.changeDetectorRef.detectChanges();
      } else  {
        if (user?.client && user?.client.backgroundImageBlobName) {
          const imageBlob = await lastValueFrom(this.apiService.getStorageImageBlob(user?.client.backgroundImageBlobName));
          if (imageBlob) {
            if (this.currentBlobUrl) {
              URL.revokeObjectURL(this.currentBlobUrl);
            }
            this.currentBlobUrl = URL.createObjectURL(imageBlob);
            this.clientBackgroundUrl = `url(${this.currentBlobUrl})`;
            this.changeDetectorRef.detectChanges();
          }
        } else {
          this.clientBackgroundUrl = 'url(/assets/bg1.webp)';  // Replace with actual default image path
          this.changeDetectorRef.detectChanges();
        }

      }
    });
  }

  ngOnDestroy(): void {
    this.isLoadingSubscription.unsubscribe();
    this.userSubscription.unsubscribe();

    // Clean up blob URL to prevent memory leak
    if (this.currentBlobUrl) {
      URL.revokeObjectURL(this.currentBlobUrl);
    }
  }
}
